import type { IObjectiveRateType } from './ObjectiveRateType.interface';
import ObjectiveTypeBase from './ObjectiveTypeBase';

export default class ObjectiveRateType implements IObjectiveRateType {
  fixed: ObjectiveTypeBase;
  variable: ObjectiveTypeBase;
  fixedAndVariable: ObjectiveTypeBase;

  static build = (data: IObjectiveRateType) => new ObjectiveRateType(data);
  static blank = () => new ObjectiveRateType();

  /**
   * Constructor
   * @param {IObjectiveRateType} data
   */
  constructor(data?: IObjectiveRateType) {
    this.fixed = new ObjectiveTypeBase(data?.fixed);
    this.variable = new ObjectiveTypeBase(data?.variable);
    this.fixedAndVariable = new ObjectiveTypeBase(data?.fixedAndVariable);
  }
}
